export const lang: any = {
    jp: {
        title: 'DELTA 3 1000 Airに関する注釈',
        item_1: '*¹ 950Wh～1,100Wh容量帯のLFPバッテリー採用かつ双方向インバーター搭載ポータブル電源比 (自社調べ、2025年8月時点)',
        item_2: '*² 日本国内で販売されている950Wh～1,100Wh容量帯のLFPバッテリー採用かつ双方向インバーター搭載ポータブル電源比 (自社調べ、2025年8月時点)',
        item_3: 'DELTA 3 1000 Airに関する販売規約',
        item_4: '1.DELTA 3 1000 Airは、2025年11月6日（木）より予約開始、2025年11月15日（月）に発売開始。',
    },
};
